module.exports = __webpack_public_path__ + "static/media/Group_learning.7f06c052.svg";